import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const supportedLanguages = ["en", "am"];

const useLanguageListener = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "LANGUAGE_CHANGED") {
        const language = event.data?.language;

        if (supportedLanguages.includes(language)) {
          localStorage.setItem("language", language);
          i18n.changeLanguage(language);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [i18n]);
};

export default useLanguageListener;
